module.exports = '<svg width="41" height="32" viewBox="0 0 41 32"><path d="M25.001 16a4.571 4.571 0 1 1-9.142 0 4.571 4.571 0 0 1 9.142 0zM20.407 0C12.359 0 4.656 5.76.338 15.017l-.238.514c-.137.283-.133.738.007 1.017l.251.503C4.977 26.125 12.838 32 20.406 32c7.543 0 15.015-5.486 20-14.674 0 0 .135-.245.297-.549s.169-.795.011-1.097l-.286-.549C35.397 5.508 28.083 0 20.405 0zm.023 25.143c-5.051 0-9.145-4.094-9.145-9.143s4.094-9.143 9.145-9.143c5.047 0 9.141 4.094 9.141 9.143s-4.094 9.143-9.141 9.143z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/eye-3.js
// module id = 1136
// module chunks = 14